import VesselPositionData from "./data"

export default function mapVesselPositionDataFromJson(json) {
    return new VesselPositionData(
        json['eta_next_port'],
        json['coords'],
        json['insert_date'],
        json['avg_speed'],
        json['me_hsfo'],
        json['me_lsfo'],
        json['me_vlsfo'],
        json['me_ulsfo']
    )
}
